var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-page-no-result"},[_c(_vm.iconComponent,{tag:"component"}),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }